import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/funds/rescuev2_top_banner.png'
import _imports_1 from '@/assets/funds/rescuev2_card.png'
import _imports_2 from '@/assets/funds/rescuev2_middle_banner.png'


const _hoisted_1 = { class: "funds_container" }
const _hoisted_2 = { class: "funds-card" }
const _hoisted_3 = { class: "top-funds" }
const _hoisted_4 = { class: "top-text" }
const _hoisted_5 = { class: "funds-card-middle" }
const _hoisted_6 = { class: "middle-funds" }
const _hoisted_7 = { class: "middle-text" }
const _hoisted_8 = { class: "table-title" }
const _hoisted_9 = { style: {"color":"#FFFFFF","font-size":"14px"} }
const _hoisted_10 = { class: "table-title" }
const _hoisted_11 = { style: {"color":"#FFFFFF"} }
const _hoisted_12 = { class: "table-title" }
const _hoisted_13 = { style: {"color":"#FFFFFF"} }
const _hoisted_14 = { class: "table-text" }
const _hoisted_15 = { class: "table-text" }
const _hoisted_16 = { class: "table-text" }
const _hoisted_17 = { class: "activity-title" }
const _hoisted_18 = ["innerHTML"]

import CustomHeader from '../components/common/customHeader.vue';
import { ref } from 'vue'
import { COMMISSION_LIST, FundViewData } from '@/view/funds/fundsView'; 

export default /*@__PURE__*/_defineComponent({
  __name: 'fundsView',
  props: {
    dataSet: {}
  },
  setup(__props: any) {

const commissionList = ref(COMMISSION_LIST);
const props = __props

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('funds.rescueFunds')
    }, null, 8, ["text"]),
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "24" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "weekly-banner" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "banner",
                class: "weekly-img"
              })
            ], -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _cache[1] || (_cache[1] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: "banner",
                  class: "top-card-bg"
                }, null, -1)),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('funds.currentLoss')), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "top-amount" }, [
                  _createTextVNode("R$ "),
                  _createElementVNode("span", { style: {"font-size":"23px"} }, " 0")
                ], -1)),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('funds.plannedFunds')), 1),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "top-bottom-amount" }, [
                  _createTextVNode("R$ "),
                  _createElementVNode("span", { style: {"font-size":"23px","color":"#FFFFFFD9"} }, " 0")
                ], -1))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: "banner",
                  class: "top-card-bg"
                }, null, -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('funds.currentLoss')), 1),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "middle-amount" }, [
                  _createTextVNode("R$ "),
                  _createElementVNode("span", { style: {"font-size":"23px"} }, " 0")
                ], -1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('funds.plannedFunds')), 1),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "middle-bottom-amount" }, [
                  _createTextVNode("R$ "),
                  _createElementVNode("span", { style: {"font-size":"23px","color":"#FFFFFFD9"} }, " 0")
                ], -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.dataSet.availableBalance > 0 ? 'exchange-btn exchange-btn-active' : 'exchange-btn exchange-btn-disabled')
                }, null, 2)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "funds-middle-banner" }, [
        _createElementVNode("img", {
          src: _imports_2,
          alt: "banner",
          class: "top-card-bg"
        })
      ], -1)),
      _createVNode(_component_van_row, {
        gutter: "8",
        class: "detail-table"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('common.level')), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "10" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('funds.gameLoss')), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "10" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('funds.redeemFee')), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commissionList.value, (i, index) => {
        return (_openBlock(), _createBlock(_component_van_row, {
          key: i + 'i'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "4",
              class: _normalizeClass(['table-row', index % 2 === 0 ? 'light' : 'dark'])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, _toDisplayString(i.level), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_van_col, {
              span: "10",
              class: _normalizeClass(['table-row', index % 2 === 0 ? 'light' : 'dark'])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_15, _toDisplayString(i.title), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_van_col, {
              span: "10",
              class: _normalizeClass(['table-row', index % 2 === 0 ? 'light' : 'dark'])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_16, _toDisplayString(i.value), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_van_row, { class: "activity-title-row" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "6" }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "left-img" }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "6" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("div", { class: "right-img" }, null, -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: "activity-text",
                innerHTML: _ctx.$t('funds.activityContent')
              }, null, 8, _hoisted_18)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})